import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from 'ng2-translate';
import { PostService } from './../_services/post.service';
import {
  Component, OnInit, Input, ChangeDetectionStrategy, SimpleChanges,
  ChangeDetectorRef, ElementRef, ViewChild, Output, EventEmitter, OnDestroy, OnChanges,
} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../_services/alert.service';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from '../_services/loader.service';
import { UserService } from '../_services/user.service';
import { Observable, BehaviorSubject } from 'rxjs';
import 'rxjs/add/operator/do';
import { MediaMatcher } from '@angular/cdk/layout';
import { SaveMessageComponent } from '../directive/save-message/save-message.component';
import { MatDialog } from '@angular/material';
import { PhoneTakeRequestComponent } from '../directive/phone-take-request/phone-take-request.component';
import { MetaService } from 'ng2-meta';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';


@Component({
  selector: 'post',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            style({ transform: 'translateX(-100%)', opacity: 0 }),
            animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
          ]
        ),
        transition(
          ':leave', [
            style({ transform: 'translateX(0)', 'opacity': 1 }),
            animate('500ms', style({ transform: 'translateX(-100%)', 'opacity': 0 }))
          ]
        )])
  ],
})

export class PostComponent implements OnInit, OnDestroy, OnChanges {
  emptyData = {
    "innerText": "@apple İzmir Egemek Apple servisine 3 defa telefonumda arıza var diye teslim ettim her teslim tutanağında aynı şikayetlerde bulundum hemen hemen ama sorunun çözüldüğüne inanmıyorum. 3 ay önce telefonu götürdüğümde hoparlörden ses gelmiyor diye şikayetçi oldum on ekran değiştirildi ve bana teslim edildi. Geçen hafta fark ettim ekranın alt kısmında hafif bir açılma var ve aynı şikayetlerimin olduğunu belirttim mesela şarj çabuk bitiyor, şarjda cihaz çok ısınıyor ekranın sol üst köşesi bazen dokunmatik temas etmiyor ve arama esnasında arama hatası veriyor dedim kayıtları alan arkadaş kontrol ederken kasanın yamuk olduğunu garantinin karşılamayacağını söyledi. Telefonda darbe yok çizik yok bende arkadaşa dedim darbe olur anlarım ya sizin personeliniz değişim esnasında bir hata yaptıysa bilmiyorum dedi ve cihazı teslim aldı 5 gün sonra servisten beni aradılar 1900 TL civarı para verirsem yeni bir cihaz vereceklerini söylediler. Şimdi bu müşteri memnuniyetini bana açıklar misiniz ben hem garanti kapsamında olan cihazımı servise getireceğim hem de hiçbir hizmet alamayacağım inanın çok pişmanım bu zamana kadar iPhone kullandığıma yazıklar olsun #şikayetimvar",
    "ipAddres": "176.54.229.97",
    "modifyDate": 1545914303798,
    "order": -1545914303798,
    "postInPath": [],
    "rating": {
      "userRate": 4.8,
      "name": "Apple"
    },
    "settings": {},
    "text": "qq",
    "author": {
      "firstname": "Muharrem",
      "lastname": "Dengiz",
      "level": 0,
      "profileImage": "no-image.png",
      "userKey": "k6PCjCe9hXhYjnGKmRdfCDFny142",
      "username": "mdengiz",
    },
    "valueOf": 0,
    "valueOf_ModifyDate": -1545914303798
  };
  Customer = null;
  Customers = [
    {
      CustomerId: 1, Name: "John Hammond",
      Link: "https://blog.bigadvice.com/2019/04/15/internetten-alisveris-yaparken-dikkat-edilmesi-gerekenler-2/", Photo: "assets/images/yataybanner1.jpg"
    },
    { CustomerId: 2, Name: "Mudassar Khan", Link: "https://blog.bigadvice.com/", Photo: "assets/images/yataybanner2.jpg" },
    { CustomerId: 3, Name: "Suzanne Mathews", Link: "https://blog.bigadvice.com/2019/10/23/bir-torbanin-tuhaf-hikayesi/", Photo: "assets/images/yataybanner3.jpg" }
  ];
  item: Observable<any[]>;
  posts = new BehaviorSubject<any>([]);
  emptyAlert = false;
  private subscription: Subscription = new Subscription();
  offset: number;
  postRef: firebase.database.Query;
  sub: Subscription;
  recentPostRef: any;
  recentPostsLength = 0;
  scrollDistance = 50;
  companyBannerImage3: any;
  bannerLink2: any;
  hashtagName: string;
  user: any;
  model: any[] = [];
  userId = localStorage.getItem('currentUserId');
  orderBy = 'order';
  isLoadable: boolean;
  differ: any;
  postHomesubscribe: Subscription = new Subscription();
  type: any;
  postSubsc: Subscription = new Subscription();
  postSubsc2: Subscription = new Subscription();
  postSubsc3: Subscription = new Subscription();
  postSubsc4: Subscription = new Subscription();
  postSubscNewPosts: Subscription = new Subscription();
  product: any;
  hashtag: any;
  hahstags: any;
  silencedUser: any;
  flipped: boolean;
  index = 0;
  x;
  isMobile: boolean;
  @Input() key: any;
  @Input() followPosts: any;
  @Input() order: any;
  @Input() whichPage: any;
  @Input() changesHashtag: any;
  @Input() value: string;
  @Input() specialPosts: any;
  @Input() welcomePost: any;
  @Input() whichId: string;
  page: any;
  @ViewChild('rateMenu') rateMenu: ElementRef;
  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService,
    public modalService: NgbModal,
    private router: Router,
    private afs: AngularFirestore,
    public loaderService: LoaderService,
    private userService: UserService,
    private media: MediaMatcher,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private alertService: AlertService,
    private postSw: PostService,
    private metaService: MetaService) {
    this.translate.setDefaultLang("tr");
    //this.differ = differs.find({}).create();
    this.isMobile = this.media.matchMedia('(max-width: 768px)').matches;

  }

  trackByFn(index, post) {
    return post.id;
  }

  open(content, ctrl) {
    if (this.userId) {
      this.afs.collection('posts').ref.where('user', '==', this.userId).get().then(data => {
        const x = [];
        data.forEach(post => {
          if (post.data().modifyDate > Date.now() - 86400000) {
            x.push(post.data());
          }
        });
        if (x.length >= 10 && ctrl === 0) {
          this.dialog.open(SaveMessageComponent, {
            width: '600px',
            data: {
              message: 'Günlük paylaşım hakkını doldurdun, ama biz seni dinlemeye doyamadık! Yarın yeni paylaşımların için bekliyoruz :)',
              type: "update"
            }
          });

        }
        else {

          this.modalService.open(content, { backdrop: "static" });
        }
      })


    } else {
      this.router.navigate(["/auth"]);
    }
  }
  ngOnChanges(changes: SimpleChanges) {


    this.loaderService.load(true);
    this.loadPosts(this.key);
  }
  start() {
    this.Customer = this.Customers[this.index];
    setInterval(() => {
      this.Customer = this.Customers[this.index];

      this.index++;
      if (this.index > this.Customers.length - 1) {
        this.index = 0;
      }
      this.cd.markForCheck();


    }, 4000)

  }

  ngOnInit() {


    this.start();
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;


    }));

    this.subscription.add(this.route.params.subscribe(params => {
      const uniqueName = decodeURIComponent(params["uniqueName"]).split("#")[0];
      this.subscription.add(this.afs.collection('entities', ref => ref.where('uniqueName', '==', uniqueName))
        .valueChanges().subscribe((data => {
          this.product = data.filter(a => {
            return a['type'] !== 'hashtag' && a['type'] !== 'user';
          });
          this.product = this.product[0];
        })));
      if (this.whichPage === 'brand') {
        this.afs.collection('brands').ref.where('uniqueName', '==', uniqueName).get().then((data => {
          if (data.docs[0].data().bannerImage3) {
            this.companyBannerImage3 = data.docs[0].data().bannerImage3;
          }
          if (data.docs[0].data().bannerLink2) {
            this.bannerLink2 = data.docs[0].data().bannerLink2;
          }
        }))
      }

    }))





  }

  isSilencedUser(username) {
    return this.afs.collection('users').doc(this.user.id).collection('silencedUser').ref.where('username', '==', username).get().then((data => {
      if (!data.empty) {
        return true
      }
      else {
        return false;
      }
    }))
    // this.afs.collection('users').doc(this.user.id).doc('silencedUser').
    // try {
    //   let array = Object.values(this.user.silencedUser);
    //   console.log(array);
    //   return !array.every((data: any) => username != data.username);
    // } catch (e) {
    //   return false;
    // }
  }



  loadPosts(path, opts?) {
    this.postSubsc.unsubscribe();
    this.postSubsc2.unsubscribe();
    this.postSubsc3.unsubscribe();
    this.postSubsc4.unsubscribe();
    this.postHomesubscribe.unsubscribe();
    this.postSubscNewPosts.unsubscribe();
    this.postSubsc3 = new Subscription();
    this.postSubsc2 = new Subscription();
    this.postSubsc4 = new Subscription();
    // this.postHomesubscribe = new Subscription();


    if (this.whichPage === 'homepage' && this.recentPostsLength === 0) {

      if (this.orderBy === 'order') {
        this.loadRecentPosts();
      }

      this.item = this.afs.collection('posts', ref => ref.orderBy('order').limit(this.scrollDistance))
        .snapshotChanges()
        .pipe(
          map(changes => {
            return changes.filter(mail => mail.payload.doc.data()['repostedByUser'] === undefined)
              .map(c => ({ id: c.payload.doc.id, ...c.payload.doc.data() }));
          })
        )

      // this.item = this.afs.collection('posts', ref => ref.orderBy('order')
      //   .limit(this.scrollDistance)).snapshotChanges().pipe(map(actions => {
      //     return actions.map(a => {
      //       return {
      //         id: a.payload.doc.id,
      //         ...a.payload.doc.data()
      //       }
      //     })
      //   }))
      this.postHomesubscribe = new Subscription();
      this.postHomesubscribe = this.item.subscribe(postHome => {


        if (postHome.length == 0) {
          this.emptyAlert = true;
        }
        else {
          this.emptyAlert = false;
        }
        this.posts.next(postHome);


        this.loaderService.load(false);
        let distance = this.scrollDistance == 17 ? this.scrollDistance : this.scrollDistance - 50;
        this.isLoadable = distance <= postHome.length;
      });
      this.cd.markForCheck();



    }

    if (this.whichPage === 'banaozel') {

      const arr: Object[] = [];
      this.postSubsc3.add(this.userService.getFollowing().subscribe(followers => {
        followers.push({ id: this.userId });
        followers.forEach(element => {

          if (element['id']) {
            this.postSubsc3.add(this.afs.collection('posts', ref => ref.where('user', '==', element['id'])
              .orderBy('order').limit(this.scrollDistance))
              .snapshotChanges().pipe(map(data => {
                return data.map(actions => {
                  return {
                    id: actions.payload.doc.id,
                    ...actions.payload.doc.data()

                  };
                });
              })).subscribe(post => {
                post.forEach(data => {
                  const index = arr.findIndex(d => d['id'] === data.id);
                  if (index === -1) {
                    arr.push(data);
                  } else {
                    arr[index] = data;
                  }
                  this.cd.markForCheck();
                });
                this.loaderService.load(false);
                if (arr.length === 0) {
                  this.emptyAlert = true;

                }
                else {
                  this.emptyAlert = false;
                }

              }));

          }
        });

        this.posts.next(arr);

      }));
      let distance = this.scrollDistance == 17 ? this.scrollDistance : this.scrollDistance - 50;
      this.isLoadable = distance <= arr.length;
      this.cd.markForCheck();
    }
    if (this.whichPage === 'user') {
      this.posts.next([]);
      this.loaderService.load(true);
      this.postSubsc2.add(this.afs.collection('posts', ref => ref.where(this.value, '==', this.key).orderBy(this.order)
        .limit(this.scrollDistance)).snapshotChanges().pipe(map(actions => {
          return actions.map(a => {
            return {
              id: a.payload.doc.id,
              ...a.payload.doc.data()
            }
          })
        }))
        .subscribe(post => {
          if (post.length == 0) {
            this.emptyAlert = true;

          }
          else {
            this.emptyAlert = false;
          }
          if (this.whichPage !== 'brand') {
            this.posts.next(post);
          }


          this.loaderService.load(false);

          if (this.welcomePost) {
            this.afs.collection('welcomePosts').ref.where('username', '==', this.key).get().then((welcomePost) => {
              if (!welcomePost.empty) {
                let welcomeArray = [];
                welcomeArray.push(welcomePost.docs[0].data())
                post.push(welcomeArray[0]);
                this.posts.next(post);
              }
            })
            this.type = 'user';
          }

          let distance = this.scrollDistance == 17 ? this.scrollDistance : this.scrollDistance - 50;
          this.isLoadable = distance <= post.length;
          this.cd.markForCheck();
        }));

    }
    if (this.whichPage === 'category' || this.whichPage === 'brand' || this.whichPage === 'product') {

      this.posts.next([]);
      this.loaderService.load(true);
      this.postSubsc2.add(this.afs.collection('posts', ref => ref.where(this.value, '==', this.key).orderBy(this.order)
        .limit(this.scrollDistance)).snapshotChanges().pipe(map(changes => {
          return changes.filter(mail => mail.payload.doc.data()['repostedByUser'] === undefined).map(c => ({ id: c.payload.doc.id, ...c.payload.doc.data() }));
        }))
        .subscribe(post => {
          if (post.length == 0) {
            this.emptyAlert = true;

          }
          else {
            this.emptyAlert = false;
          }
          if (this.whichPage !== 'brand') {
            this.posts.next(post);
          }


          this.loaderService.load(false);
          if (this.whichPage === 'brand') {
            this.afs.collection('posts').ref.where('mention-' + this.key, '==', true).get().then(data => {
              if (!data.empty) {

                let x = [];
                data.docs.map(a => {
                  if (a.data().rating.uniqueName !== this.key) {
                    post.push({ id: a.id, ...a.data() });
                  }



                })

                this.posts.next(post.sort(function (a, b) {
                  a = a['order'];
                  b = b['order'];
                  return a > b ? 1 : a < b ? -1 : 0;
                }));


              }
              else {
                this.posts.next(post);

              }

            })



          }
          if (this.welcomePost) {
            this.afs.collection('welcomePosts').ref.where('username', '==', this.key).get().then((welcomePost) => {
              if (!welcomePost.empty) {
                let welcomeArray = [];
                welcomeArray.push(welcomePost.docs[0].data())
                post.push(welcomeArray[0]);
                this.posts.next(post);
              }
            })
            this.type = 'user';
          }

          let distance = this.scrollDistance == 17 ? this.scrollDistance : this.scrollDistance - 50;
          this.isLoadable = distance <= post.length;
          this.cd.markForCheck();
        }));

    }
    if (this.whichPage === 'hashtag') {

      if (this.value === 'şikayetimvar' || this.value === 'markamaönerim'
        || this.value === 'benimtavsiyem' || this.value === 'bunuçoksevdim') {
        this.posts.next([]);
        this.loaderService.load(true);
        this.postSubsc4.add(this.afs.collection('posts',
          ref => ref.where('tag-' + this.value, '==', true)
            .orderBy(this.order).limit(this.scrollDistance)).snapshotChanges().pipe(map(changes => {
              return changes.filter(mail => mail.payload.doc.data()['repostedByUser'] === undefined)
                .map(c => ({ id: c.payload.doc.id, ...c.payload.doc.data() }));
            })).subscribe(post => {

              this.posts.next(post);

              this.loaderService.load(false);
              let distance = this.scrollDistance == 17 ? this.scrollDistance : this.scrollDistance - 50;
              this.isLoadable = distance <= post.length;
              this.cd.markForCheck();
            }));
      }
      else {
        this.postSubsc = this.afs.collection('posts', ref => ref
          .where('tag-' + this.value, '==', true)).snapshotChanges().pipe(map(changes => {
            return changes.filter(mail => mail.payload.doc.data()['repostedByUser'] === undefined)
              .map(c => ({ id: c.payload.doc.id, ...c.payload.doc.data() }));
          })).subscribe(data => {
            if (data.length == 0) {
              this.emptyAlert = true;

            }
            else {
              this.emptyAlert = false;
            }
            this.posts.next(data.sort(function (a, b) {
              a = a['order'];
              b = b['order'];
              return a > b ? 1 : a < b ? -1 : 0;
            }));
            this.loaderService.load(false);
            this.cd.markForCheck();
            let distance = this.scrollDistance == 17 ? this.scrollDistance : this.scrollDistance - 50;
            this.isLoadable = distance <= data.length;
          }
          )

      }

    }
    if (this.changesHashtag === 'bunuçoksevdim') {
      this.postSubsc = this.afs.collection('posts', ref =>
        ref.where('rating.category', '==', path).orderBy('order')).snapshotChanges().pipe(map(changes => {
          return changes.filter(mail => mail.payload.doc.data()['repostedByUser'] === undefined)
            .map(c => ({ id: c.payload.doc.id, ...c.payload.doc.data() }));
        })).subscribe(post => {
          const hash = [];
          post.forEach(b => {
            if (b['tag-bunuçoksevdim']) {
              hash.push(b);
            }
          })
          this.posts.next(hash)
          this.loaderService.load(false)
        })
    }
    if (this.changesHashtag === 'tavsiyeedilenler') {
      this.postSubsc = this.afs.collection('posts',
        ref => ref.where('rating.category', '==', path).orderBy('order')).snapshotChanges().pipe(map(changes => {
          return changes.filter(mail => mail.payload.doc.data()['repostedByUser'] === undefined)
            .map(c => ({ id: c.payload.doc.id, ...c.payload.doc.data() }));
        })).subscribe(post => {
          const hash = [];
          post.forEach(b => {
            if (b['tag-benimtavsiyem']) {
              hash.push(b);
            }
          })
          this.posts.next(hash)
          this.loaderService.load(false)
        })
    }
    if (this.whichPage === 'favorites') {
      this.postSubsc = this.afs.collection('posts',
        ref => ref.where('follow-' + this.value, '==', true)).snapshotChanges().pipe(map(actions => {
          return actions.map(a => {
            return {
              id: a.payload.doc.id,
              ...a.payload.doc.data()
            }
          })
        })).subscribe(data => {
          if (data.length == 0) {
            this.emptyAlert = true;

          }
          else {
            this.emptyAlert = false;
          }
          this.posts.next(data.sort(function (a, b) {
            a = a['order'];
            b = b['order'];
            return a > b ? 1 : a < b ? -1 : 0;
          }));
          this.loaderService.load(false);
          this.cd.markForCheck();
          let distance = this.scrollDistance == 17 ? this.scrollDistance : this.scrollDistance - 50;
          this.isLoadable = distance <= data.length;
        }
        )

    }
    // if (this.orderBy === 'order') {
    //   this.loadRecentPosts();
    // }
    this.cd.markForCheck();


  }
  loadRecentPosts() {
    let date = -1 * (Date.now() + (this.offset || 0));

    this.postSubscNewPosts = this.afs.collection('posts', ref => ref.orderBy('order').endAt(date)).valueChanges().subscribe(a => {


      a.forEach(data => {

        let username = data['author'].username;
        let bool = this.isSilencedUser(data['author'].username);
        let reposted = data['repostedByUser'] ? data['repostedByUser'].username : null;
        let isMyPost = data['order'] && (username === this.user.username || reposted === this.user.username)
        if (username && isMyPost && data[this.orderBy]) {

          this.scrollDistance = 17;
          this.loadPosts('newPost');
          this.recentPostsLength = 0;
          this.cd.markForCheck();
        }

        bool.then((a => {

          if (username && !a && !isMyPost && data[this.orderBy]) {

            this.recentPostsLength++;
            this.postHomesubscribe.unsubscribe();
          }
          this.postSubscNewPosts.unsubscribe();
          this.cd.markForCheck();
        }))

      })
    })



  }


  requestPhone(content) {
    console.log(content);
    if (this.userId) {
      this.dialog.open(PhoneTakeRequestComponent, {
        width: 'auto',
        height: '80%',
        data: {
          title: 'Tebrikler!',
          type: "badge",
          image: "categoryIcons/" + "category.uniqueName" + ".png",
          content: "category.name" + ' kategorisinde uzmanlık kazandın.'
        }
      });
    }
    else {
      this.modalService.open(content, { backdrop: "static" });
    }
  }


  loadMore() {
    if (!this.userId) {
      this.router.navigate(['/auth']);
      return;
    }
    this.scrollDistance += 50;
    this.cd.markForCheck();
    this.loaderService.load(true);
    this.loadPosts(this.key);
  }

  reload() {
    this.recentPostsLength = 0;
    this.scrollDistance = 17;
    this.loaderService.load(true);
    this.postHomesubscribe.unsubscribe();
    this.postSubscNewPosts.unsubscribe();
    this.loadPosts('newPost');
  }


  public ngOnDestroy(): void {
    this.postHomesubscribe.unsubscribe();
    this.subscription.unsubscribe();
    this.postSubsc.unsubscribe();
    this.postSubsc3.unsubscribe();
    this.postSubscNewPosts.unsubscribe();
    this.postSubsc4.unsubscribe();
    this.postSubsc2.unsubscribe();
  }
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post/post.component.ts